import {
  GenericPipelineSettingsFragment,
  ProcessingPipelineType,
} from '@warebee/frontend/data-access-api-graphql';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '../../../components/actions/Button';
import * as Icon from '../../../components/icons';
import InputTextArea from '../../../components/inputs/InputTextArea';
import KeyValueItem from '../../../components/KeyValueItem';
import TitleSection from '../../../components/layout/TitleSection';
import { importPipelineIsActiveEditor } from '../../../importJobs/store/importPipelines.state';
import {
  processingPipelineSelected,
  processingPipelineSelectedTriggerId,
} from '../../store/processingPipelines.state';
import ProcessingPipelineGenericSectionProperties from './ProcessingPipelineGenericSectionProperties';

export const ProcessingPipelineSectionProperties: React.FC = () => {
  const { t } = useTranslation('dataset');
  const pipeline = useRecoilValue(processingPipelineSelected);

  const setTriggerId = useSetRecoilState(processingPipelineSelectedTriggerId);
  const setShowEditor = useSetRecoilState(importPipelineIsActiveEditor);

  return (
    <>
      <TitleSection
        id={`pipeline-properties`}
        title={t`Pipeline Properties`}
        inPanelView
        // className="top-12 xl:top-20 z-400"
        hasScreenTitle
        classNameInner="p-2 xl:p-4 space-y-3"
        //   collapsible
        summaryView
        hasAction={
          <Button
            label={t`Edit Pipeline`}
            className={classNames('rounded ltr:ml-4 rtl:mr-4')}
            buttonSize="xs"
            buttonType="primary"
            hasIconAfter={
              <Icon.EditPencil className={`h-5 w-5 fill-current`} />
            }
            onPress={() => {
              setTriggerId(null);
              setShowEditor(true);
            }}
          />
        }
      >
        <InputTextArea
          optional
          label={t`Pipeline Description`}
          placeholder={t`About the Pipeline...`}
          value={pipeline.description}
          isDisabled
        />

        <KeyValueItem
          keyName={t`Pipeline ID`}
          keyValue={pipeline.id}
          isDisabled={true}
          isCopyableValueOnly
          classNameKeyName="flex-1 text-sm text-menu-text/50"
          classNameKeyValue="bg-app-panel-dark/50 text-xs py-1 px-2 rounded flex-none"
          style={{
            noStyle: true,
            inline: true,
            textSize: 'xxs',
            customClassName: 'py-0.5',
          }}
        />
        <KeyValueItem
          keyName={t`Status`}
          keyValue={pipeline.enabled}
          isDisabled={true}
          classNameKeyName="flex-1 text-sm text-menu-text/50"
          classNameKeyValue="bg-app-panel-dark/50 text-xs py-1 px-2 rounded flex-none"
          style={{
            noStyle: true,
            inline: true,
            textSize: 'xxs',
            customClassName: 'py-0.5',
          }}
        />
        {pipeline.pipelineType === ProcessingPipelineType.GENERIC && (
          <ProcessingPipelineGenericSectionProperties
            settings={pipeline.settings as GenericPipelineSettingsFragment}
          />
        )}
      </TitleSection>
    </>
  );
};
